import Loader from '#/components/Loader/Loader';
import { AuthContext } from '#/screens/auth/auth.utils';
import { useContext, useEffect } from 'react';
import styles from './AuthCallback.module.scss';
import { useAppNavigation, useAppRoute } from '#/navigation/navigation.ref';
import { ToasterContext } from '#/toaster/toaster.provider';

export const AuthCallbackScreen = () => {
  const { loginWithToken, logout, accessToken } = useContext(AuthContext);
  const { params } = useAppRoute<'AuthCallback'>();
  const navigation = useAppNavigation();
  const toaster = useContext(ToasterContext);

  useEffect(() => {
    (async () => {
      if (params?.token) {
        if (accessToken) {
          await logout();
        }
        await loginWithToken({ token: params?.token, redirect: params?.redirect || 'Home' }).catch(
          () => {
            toaster.error({ message: 'Invalid token or expired session. Please try again.' });
            navigation.navigate('SignIn');
          },
        );
      } else {
        navigation.navigate('SignIn');
      }
    })();
  }, [loginWithToken, params?.token, params?.redirect]);

  return (
    <div className={styles.wrapper}>
      <Loader size={50} />
      <h3 className={styles.title}>Authenticating...</h3>
    </div>
  );
};
